/* **************************************
** MSR145 Webshop Module (Javascript)
** by MSR Electronics GmbH, www.msr.ch
** Version: 2024-03-21
*************************************** */
var priceCalculationEnabled = true;
var msrItemNo = {"Hou": "", "Int_T9": "", "Int_H3": "", "Int_P5": "", "Int_A": "", "Int_A4": "", "Int_L3": ""};
var extItems = {
	"FT2/020": 0, "FT2/100": 0, "FT2/160": 0,
	"FT3/020": 0, "FT3/100": 0, "FT3/160": 0,
	"FT9/020": 0, "FT9/100": 0, "FT9/160": 0,
	"FH3/020": 0, "FH3/100": 0, "FH3/160": 0,
	"FP10/020": 0, "FP10/100": 0, "FP10/160": 0,
	"FP7/020": 0, "FP7/100": 0, "FP7/160": 0,
	"FP3/020": 0, "FP3/100": 0, "FP3/160": 0,
	"FP4/020": 0, "FP4/100": 0, "FP4/160": 0,
	"FP8/020": 0, "FP8/100": 0, "FP8/160": 0,
	"FP9/020": 0, "FP9/100": 0, "FP9/160": 0,
	"FP12/020": 0, "FP12/100": 0, "FP12/160": 0,
	"FA/020": 0, "FA/100": 0, "FA/160": 0,
	"FA4/020": 0, "FA4/100": 0, "FA4/160": 0,
	"FL3/020": 0, "FL3/100": 0, "FL3/160": 0,
	"FD/020": 0, "FD/100": 0, "FD/160": 0,
	"FY/020": 0, "FY/100": 0, "FY/160": 0
	};
var anaAItemNumber = "";
var nItemNumbers = new Array();
var itemNumbers = "";
var pSensorsQty = [0];
var internalSensorsCount = 0;
var externalSensorsCount = 0;
var maxExternalSensors = 5;
var housingInitiallySelected = false;
var housingSelected = false;
var currentPrice = 0;
var sameSensorMultipleTimesSelected = false;
var multipleTimesSelectedSensor = "";
var configurationIsValid = false;

if (window.addEventListener) {
   window.addEventListener("load", msrInit, false);            
}
else if (window.attachEvent) {
   window.attachEvent("onload", msrInit);            
}
else {
   window.onload = msrInit;           
}
function msrInit(){
	setOptionVariables();
	loadPrices();
}
function setOptionVariables() {
	if (typeof WebshopPriceFieldId === 'undefined' && typeof CustomUpdateArgument === 'undefined') alert("You didn't define the ID of the price field. This should be done with the javascript variable 'WebshopPriceFieldId' inside the HTML header. Please refer to the installation instructions!");
	if (typeof WebshopProductNumberFieldId === 'undefined' && typeof CustomUpdateArgument === 'undefined') alert("You didn't define the ID of the product number field. This should be done with the javascript variable 'WebshopProductNumberFieldId' inside the HTML header. Please refer to the installation instructions!");
	if (typeof displayPrices === 'undefined') displayPrices = true;
	if (typeof PriceCorrectionFactor === 'undefined') PriceCorrectionFactor = 1;
	if (typeof CurrencySymbol === 'undefined') CurrencySymbol = MsrPriceList;
}
function loadPrices() {
	if(displayPrices) {
		loadCurrencySymbols();
	} else {
		hidePrices(priceList);
	}
	for(key in priceList)
	{
		try
		{
			document.getElementById(key).innerHTML = Math.round(priceList[key] * PriceCorrectionFactor).toFixed(2);
		}
		catch (e) {}
	}
}
function hidePrices(priceList) {
	for(key in priceList)
	{
		try
		{
			document.getElementById(key).style.display = "none";
		}
		catch (e) {}
	}
}
function loadCurrencySymbols() {
	// getElementsByName doesn't work with IE, so the following is a work around.
	var allSpans = document.getElementsByTagName("SPAN");
	for (i = 0, max = allSpans.length; i < max; i++)
		if(allSpans[i].id.search(/CurrencySymbol/) != -1) allSpans[i].innerHTML = CurrencySymbol;
	
}

function toggleItem(itemNo, lang)
{    
    var itemType = itemNo.substr(0,3);
    var action = document.getElementById("btn_" + itemNo).name;
	var itemQuantity = parseInt(getItemQuantity(itemNo));
	var cntFluidPBiggerThanFours = 0;
	var cntFluidPOneToFours = 0;
	var cntFluidPOnes = 0;
	for (i = 0; i < pSensorsQty.length; i++) {
		if (pSensorsQty[i] > 4) cntFluidPBiggerThanFours++;
		if (pSensorsQty[i] < 5 && pSensorsQty[i] > 0) cntFluidPOneToFours++;
		if (pSensorsQty[i] == 1) cntFluidPOnes++;
	}
    switch(action){
        case "AddItem":
			//Zu viele externe Sensoren
            if( (itemType=="Ana" && externalSensorsCount + itemQuantity > maxExternalSensors) ||
				(itemType=="Ext" && externalSensorsCount + itemQuantity > maxExternalSensors)
				){
				alert(MORE_THAN_5_EXTERNAL_SENSORS[lang]);
            }
			//Fehlende Eingangskonfiguration für Analoganschlüsse
			else if(itemNo.substr(0,3)=="Ana" && getAnalogueInputConf(itemNo).search("0")!=-1){
				alert(WRONG_NUMBER_OF_ANALOGUE_INPUT_CONFIGURATIONS_4INPUTS[lang]);
			}
            else{
				//Warnung betr. Temperaturabweichung bei internem Sensor mit Temperaturmessung
				if(itemNo == "Int_T9" || itemNo == "Int_H3" || itemNo == "Int_P5") {
					alert(INTERNAL_TEMPERATURE_WARNING_CHARGING[lang]);
				}
				//
				addItem(itemNo, itemQuantity, itemType, lang);
            }
            break;
        case "RemoveItem":
            removeItem(itemNo, itemQuantity, itemType, lang);
            break;
    }
}
function addItem(itemNo, quantity, itemType, lang)
{
	if(itemType=="Int") internalSensorsCount++;
	if(itemType=="Hou")
	{
		housingSelected = true;
	}
	if(itemType=="Ext"){
		externalSensorsCount += quantity;
	}
	if(itemType=="Int" || itemType=="Ext") updateMultipleStatus(itemNo, quantity, itemType, "add");
    if(itemType=="Hou" || itemType=="Int")
    {
        updateMsrItemNo(itemNo, itemType, "add");
    }
	else if(itemType=="Ana")
	{
		externalSensorsCount++;
		updateAnaItemNo(itemNo, "add");
	}
    else if(itemType=="Ext")
    {
        updateExtItems(itemNo, quantity, "add");
    }
    else if(itemType=="Add")
    {
        updateNItemNo(itemNo, "add");
    }
    document.getElementById("td_" + itemNo).style.backgroundColor = "#FFFF99";
    activateButton(itemNo, lang);
    disableItems(itemNo, lang);
    enableRelatedItems(itemNo, lang);
}
function removeItem(itemNo, quantity, itemType, lang)
{
	if(itemType=="Int") internalSensorsCount--;
	if(itemType=="Hou")
	{
		housingSelected = false;
	}
	if(itemType=="Ext"){
		externalSensorsCount-=quantity;
	}
	if(itemType=="Int" || itemType=="Ext") updateMultipleStatus(itemNo, quantity, itemType, "remove");
    if(itemType=="Hou" || itemType=="Int")
    {
        updateMsrItemNo(itemNo, itemType, "remove");
    }
	else if(itemType=="Ana")
	{
		externalSensorsCount--;
		updateAnaItemNo(itemNo, "remove");
	}
    else if(itemType=="Ext")
    {
        updateExtItems(itemNo, quantity, "remove");
    }
    else if(itemType=="Add")
    {
        updateNItemNo(itemNo, "remove");
    }
	resetTdBgColor(itemNo);
    enableButton(itemNo, lang);
    enableItems(itemNo, lang);
    disableRelatedItems(itemNo, lang);
}
function updateMultipleStatus(itemNo, quantity, itemType, updateInstruction)
{
	var sensor = getSensorType(itemNo, itemType);
	if(updateInstruction == "add") {
		if(parseInt(quantity) > 1 || countSelectedSensors(sensor) != 0) {
			sameSensorMultipleTimesSelected = true;
			multipleTimesSelectedSensor = sensor;
		}
	} else {
		if((parseInt(quantity) + 1 >= countSelectedSensors(sensor)) && (countSelectedSensors(sensor) > 1)) {
			sameSensorMultipleTimesSelected = false;
			multipleTimesSelectedSensor = "";
		}
	}
}
function disableItems(itemNo, lang)
{
    switch(itemNo)
    {
    case "Int_A":
        disableItemsArray(new Array("Ext_FA/020","Ext_FA/100","Ext_FA/160","Int_A4","Ext_FA4/020","Ext_FA4/100","Ext_FA4/160"), lang);
        break;
    case "Ext_FA/020":
        disableItemsArray(new Array("Int_A","Ext_FA/100","Ext_FA/160","Int_A4","Ext_FA4/020","Ext_FA4/100","Ext_FA4/160"), lang);
        break;
    case "Ext_FA/100":
        disableItemsArray(new Array("Int_A","Ext_FA/020","Ext_FA/160","Int_A4","Ext_FA4/020","Ext_FA4/100","Ext_FA4/160"), lang);
        break;
    case "Ext_FA/160":
        disableItemsArray(new Array("Int_A","Ext_FA/020","Ext_FA/100","Int_A4","Ext_FA4/020","Ext_FA4/100","Ext_FA4/160"), lang);
        break;
    case "Int_A4":
        disableItemsArray(new Array("Ext_FA/020","Ext_FA/100","Ext_FA/160","Int_A","Ext_FA4/020","Ext_FA4/100","Ext_FA4/160"), lang);
        break;
    case "Ext_FA4/020":
        disableItemsArray(new Array("Int_A","Ext_FA/100","Ext_FA/160","Int_A4","Ext_FA/020","Ext_FA4/100","Ext_FA4/160"), lang);
        break;
    case "Ext_FA4/100":
        disableItemsArray(new Array("Int_A","Ext_FA/020","Ext_FA/160","Int_A4","Ext_FA4/020","Ext_FA/100","Ext_FA4/160"), lang);
        break;
    case "Ext_FA4/160":
        disableItemsArray(new Array("Int_A","Ext_FA/020","Ext_FA/100","Int_A4","Ext_FA4/020","Ext_FA4/100","Ext_FA/160"), lang);
        break;
	case "Ext_FY/020":
        disableItemsArray(new Array("Ext_FY/100","Ext_FY/160"), lang);
        break;
    case "Ext_FY/100":
        disableItemsArray(new Array("Ext_FY/020","Ext_FY/160"), lang);
        break;
    case "Ext_FY/160":
        disableItemsArray(new Array("Ext_FY/020","Ext_FY/100"), lang);
        break;
	case "Ana_EA/020":
        disableItemsArray(new Array("Ana_EA/100","Ana_EA/160"), lang);
        break;
    case "Ana_EA/100":
        disableItemsArray(new Array("Ana_EA/020","Ana_EA/160"), lang);
        break;
    case "Ana_EA/160":
        disableItemsArray(new Array("Ana_EA/020","Ana_EA/100"), lang);
        break;
	case "Hou_145B15":
        disableItemsArray(new Array("Hou_145B7","Hou_145B4","Hou_145B16","Hou_145B8"), lang);
        break;
    case "Hou_145B7":
        disableItemsArray(new Array("Hou_145B15","Hou_145B4","Hou_145B16","Hou_145B8"), lang);
        break;
    case "Hou_145B4":
        disableItemsArray(new Array("Hou_145B15","Hou_145B7","Hou_145B16","Hou_145B8"), lang);
        break;
    case "Hou_145B16":
        disableItemsArray(new Array("Hou_145B15","Hou_145B7","Hou_145B4","Hou_145B8"), lang);
        break;
    case "Hou_145B8":
        disableItemsArray(new Array("Hou_145B15","Hou_145B7","Hou_145B4","Hou_145B16"), lang);
        break;
    }
}
function enableItems(deselectedItemNo, lang)
{
    switch(deselectedItemNo)
    {
    case "Int_A":
    case "Ext_FA/020":
    case "Ext_FA/100":
    case "Ext_FA/160":
    case "Int_A4":
    case "Ext_FA4/020":
    case "Ext_FA4/100":
    case "Ext_FA4/160":
        enableItemsArray(new Array("Int_A","Ext_FA/020","Ext_FA/100","Ext_FA/160","Int_A4","Ext_FA4/020","Ext_FA4/100","Ext_FA4/160"), lang);
        break;
    case "Hou_145B15":
    case "Hou_145B7":
    case "Hou_145B4":
    case "Hou_145B16":
    case "Hou_145B8":
        enableItemsArray(new Array("Hou_145B15","Hou_145B7","Hou_145B4","Hou_145B16","Hou_145B8"), lang);
        break;
    case "Ana_EA/020":
    case "Ana_EA/100":
    case "Ana_EA/160":
        enableItemsArray(new Array("Ana_EA/020","Ana_EA/100","Ana_EA/160"), lang);
        break;
    case "Ext_FY/020":
    case "Ext_FY/100":
    case "Ext_FY/160":
        enableItemsArray(new Array("Ext_FY/020","Ext_FY/100","Ext_FY/160"), lang);
    }
}
function enableRelatedItems(activatedItemNo, lang)
{
    switch(activatedItemNo)
    {
        case "Hou_145B15":
        case "Hou_145B4":
        case "Hou_145B16":
            if(housingInitiallySelected == false)
            {
                enableItemsArray(new Array(
					"Ext_FT2/020", "Ext_FT2/100", "Ext_FT2/160",
					"Ext_FT3/020", "Ext_FT3/100", "Ext_FT3/160",
					"Ext_FT9/020", "Ext_FT9/100", "Ext_FT9/160",
					"Ext_FH3/020", "Ext_FH3/100", "Ext_FH3/160",
					"Ext_FP10/020", "Ext_FP10/100", "Ext_FP10/160",
					"Ext_FP7/020", "Ext_FP7/100", "Ext_FP7/160",
					"Ext_FP3/020", "Ext_FP3/100", "Ext_FP3/160",
					"Ext_FP4/020", "Ext_FP4/100", "Ext_FP4/160",
					"Ext_FP8/020", "Ext_FP8/100", "Ext_FP8/160",
					"Ext_FP9/020", "Ext_FP9/100", "Ext_FP9/160",
					"Ext_FP12/020", "Ext_FP12/100", "Ext_FP12/160",
					"Ext_FA/020", "Ext_FA/100", "Ext_FA/160",
					"Ext_FA4/020", "Ext_FA4/100", "Ext_FA4/160",
					"Ext_FL3/020", "Ext_FL3/100", "Ext_FL3/160",
					"Ext_FD/020", "Ext_FD/100", "Ext_FD/160",
					"Ext_FY/020", "Ext_FY/100", "Ext_FY/160",
					"Ana_EA/020","Ana_EA/100","Ana_EA/160",
					"Int_T9", "Int_H3", "Int_P5", "Int_A", "Int_A4", "Int_L3"
				), lang);
                housingInitiallySelected = true;
            }
            break;
		case "Hou_145B7":
		case "Hou_145B8":
            if(housingInitiallySelected == false)
            {
                enableItemsArray(new Array(
					"Ext_FT2/020", "Ext_FT2/100", "Ext_FT2/160",
					"Ext_FT3/020", "Ext_FT3/100", "Ext_FT3/160",
					"Ext_FT9/020", "Ext_FT9/100", "Ext_FT9/160",
					"Ext_FH3/020", "Ext_FH3/100", "Ext_FH3/160",
					"Ext_FP10/020", "Ext_FP10/100", "Ext_FP10/160",
					"Ext_FP7/020", "Ext_FP7/100", "Ext_FP7/160",
					"Ext_FP3/020", "Ext_FP3/100", "Ext_FP3/160",
					"Ext_FP4/020", "Ext_FP4/100", "Ext_FP4/160",
					"Ext_FP8/020", "Ext_FP8/100", "Ext_FP8/160",
					"Ext_FP9/020", "Ext_FP9/100", "Ext_FP9/160",
					"Ext_FP12/020", "Ext_FP12/100", "Ext_FP12/160",
					"Ext_FA/020", "Ext_FA/100", "Ext_FA/160",
					"Ext_FA4/020", "Ext_FA4/100", "Ext_FA4/160",
					"Ext_FL3/020", "Ext_FL3/100", "Ext_FL3/160",
					"Ext_FD/020", "Ext_FD/100", "Ext_FD/160",
					"Ext_FY/020", "Ext_FY/100", "Ext_FY/160",
					"Ana_EA/020","Ana_EA/100","Ana_EA/160",
					"Int_T9", "Int_H3", "Int_P5", "Int_A", "Int_A4", "Int_L3"
				), lang);
                housingInitiallySelected = true;
            }
			enableItemsArray(new Array("Add_N10006"), lang);
            break;
    }
}
function disableRelatedItems(deactivatedItemNo, lang)
{
    switch(deactivatedItemNo)
    {
		case "Hou_145B7":
		case "Hou_145B8":
            disableItemsArray(new Array("Add_N10006"), lang);
            break;
    }
}
function disableItemsArray(itemsArray, lang)
{
    var x;
    for(x=0;x<itemsArray.length;x++)
    {
        var itemType = itemsArray[x].substr(0,3);
		if(itemType=="Add" && document.getElementById("btn_" + itemsArray[x]).name == "RemoveItem")
        {
            updateNItemNo(itemsArray[x], "remove");
        }
		resetTdBgColor(itemsArray[x]);
        disableButton(itemsArray[x], lang);
    }
}
function enableItemsArray(itemsArray, lang)
{
    var x;
    for(x=0;x<itemsArray.length;x++)
    {
		resetTdBgColor(itemsArray[x]);
        enableButton(itemsArray[x], lang);
    }
}
function disableButton(itemNo, lang)
{
	var buttonId = "btn_" + itemNo;
    document.getElementById(buttonId).style.backgroundColor = "#CCCCCC";
    document.getElementById(buttonId).style.color = "#FFFFFF";
	document.getElementById(buttonId).innerHTML = SELECT_BTN[lang];
    document.getElementById(buttonId).name = "AddItem";
    document.getElementById(buttonId).disabled = "disabled";
	if(document.getElementById("ddl_" + itemNo + "_qty")) document.getElementById("ddl_" + itemNo + "_qty").disabled = "disabled";
}
function enableButton(itemNo, lang)
{
	var buttonId = "btn_" + itemNo;
    document.getElementById(buttonId).style.backgroundColor = "#CCCCCC";
    document.getElementById(buttonId).style.color = "#0033CC";
	document.getElementById(buttonId).innerHTML = SELECT_BTN[lang];
    document.getElementById(buttonId).name = "AddItem";
    document.getElementById(buttonId).disabled = "";
	if(document.getElementById("ddl_" + itemNo + "_qty")) document.getElementById("ddl_" + itemNo + "_qty").disabled = "";
}
function activateButton(itemNo, lang)
{
	var buttonId = "btn_" + itemNo;
    document.getElementById(buttonId).style.backgroundColor = "#0033CC";
    document.getElementById(buttonId).style.color = "#FFFFFF";
	document.getElementById(buttonId).innerHTML = REMOVE_BTN[lang];
    document.getElementById(buttonId).name = "RemoveItem";
    document.getElementById(buttonId).disabled = "";
	if(document.getElementById("ddl_" + itemNo + "_qty")) document.getElementById("ddl_" + itemNo + "_qty").disabled = "disabled";
}
function updateMsrItemNo(itemNo, itemType, updateInstruction)
{
	if(itemType=="Hou")
    {
        if(updateInstruction == "add")
        {
            msrItemNo[itemType] = itemNo.slice(itemNo.indexOf("_")+1);
        }
        else
        {
            msrItemNo[itemType] = "";
        }
    }
    else if(itemType=="Int")
    {
        if(updateInstruction == "add")
        {
            msrItemNo[itemNo] = itemNo.slice(itemNo.indexOf("_")+1);
        }
        else
        {
            msrItemNo[itemNo] = "";
        }
    }
    if(priceCalculationEnabled)
    {
        if(updateInstruction == "add")
        {
			updatePrice(parseFloat(document.getElementById(itemNo+"Price").innerHTML));
        }
        else
        {
			updatePrice(-(parseFloat(document.getElementById(itemNo+"Price").innerHTML)));
        }
    }
    updateItemNumbers();
}
function updateAnaItemNo(itemNo, updateInstruction)
{
	var anaConnectorId = itemNo.charAt(5);
	if(updateInstruction == "add")
	{
		conf = getAnalogueInputConf(itemNo);
		anaAItemNumber = itemNo.slice(itemNo.indexOf("_")+1).replace("A",conf);
		document.getElementById(itemNo+"ItemNo").innerHTML = anaAItemNumber;
	}
	else
	{
		document.getElementById(itemNo+"ItemNo").innerHTML = "Exxxx"+anaAItemNumber.substring(5);
		anaAItemNumber = "";
	}
    if(priceCalculationEnabled)
    {
        if(updateInstruction == "add")
        {
        	updatePrice(parseFloat(document.getElementById(itemNo+"Price").innerHTML));
        }
        else
        {
            updatePrice(-(parseFloat(document.getElementById(itemNo+"Price").innerHTML)));
        }
    }
    updateItemNumbers();
}
function updateExtItems(itemNo, quantity, updateInstruction)
{
    if(updateInstruction=="add")
    {
		extItems[itemNo.slice(itemNo.indexOf("_")+1)] = extItems[itemNo.slice(itemNo.indexOf("_")+1)] + quantity;
        if(priceCalculationEnabled)
        {
            updatePrice(parseFloat(document.getElementById(itemNo+"Price").innerHTML) * quantity);
        }
    }
    else
    {
		extItems[itemNo.slice(itemNo.indexOf("_")+1)] = extItems[itemNo.slice(itemNo.indexOf("_")+1)] - quantity;
		if(priceCalculationEnabled)
		{
			updatePrice(-(parseFloat(document.getElementById(itemNo+"Price").innerHTML) * quantity));
		}
    }
    updateItemNumbers();
}
function updateNItemNo(itemNo, updateInstruction) // NItem müsste "AddItem" heissen, d.h. es sind die zusätzlichen Produkte
{
    if(updateInstruction=="add")
    {
        nItemNumbers.push(itemNo.slice(itemNo.indexOf("_")+1));
        if(priceCalculationEnabled)
        {
            updatePrice(parseFloat(document.getElementById(itemNo+"Price").innerHTML));
        }
    }
    else
    {
        var nItemNumbersLength = nItemNumbers.length;
        for(i=0;i<nItemNumbersLength;i++)
        {
            var nItem = nItemNumbers.shift();
            if(nItem != itemNo.slice(itemNo.indexOf("_")+1))
            {
                nItemNumbers.push(nItem);
            }
            else
            {
                if(priceCalculationEnabled)
                {
                    updatePrice(-(parseFloat(document.getElementById(itemNo+"Price").innerHTML)));
                }
            }
        }
    }
    nItemNumbers.sort();
    updateItemNumbers();
}
function updateItemNumbers()
{
    itemNumbers = "";
    for (var x in msrItemNo)
    {
        itemNumbers += msrItemNo[x];
    }
	if(anaAItemNumber.length>0)
	{
		itemNumbers += " & " + anaAItemNumber;
	}
    for (var x in extItems)
    {
		var qty = extItems[x];
		if(qty > 0) {
			for(var i = 0; i < qty; i++)
			{
				itemNumbers += " & " + x;
			}
		}
    }
    if(nItemNumbers.length>0)
    {
        for(i=0;i<nItemNumbers.length;i++)
        {
            itemNumbers += " & " + nItemNumbers[i];
        }
    }
	if (typeof CustomUpdateArgument !== 'undefined') {
		eval(CustomUpdateArgument);
	} else {
		document.getElementById(WebshopProductNumberFieldId).value = itemNumbers;
	}
	pSensorsQty = [
					(itemNumbers.match(/P3/g) != null ? itemNumbers.match(/P3/g).length : 0),
					(itemNumbers.match(/P4/g) != null ? itemNumbers.match(/P4/g).length : 0),
					(itemNumbers.match(/P8/g) != null ? itemNumbers.match(/P8/g).length : 0),
					(itemNumbers.match(/P9/g) != null ? itemNumbers.match(/P9/g).length : 0),
					(itemNumbers.match(/P12/g) != null ? itemNumbers.match(/P12/g).length : 0)
				];
	updateConfIsValid();
}
function updateConfIsValid()
{
	if (typeof WebshopConfIsValidFieldId === 'undefined')
	{
		validateMsrConfiguration("none", false);
	}
	else
	{
		document.getElementById(WebshopConfIsValidFieldId).value = validateMsrConfiguration("none", false);
	}
}
function updatePrice(amount)
{
    currentPrice = currentPrice + amount;
    if (typeof CustomUpdateArgument === 'undefined') document.getElementById(WebshopPriceFieldId).value = currentPrice.toFixed(2);
}
function countSelectedSensors(sensorType) { //sensorType: T, H, L etc.
	var matchesArray = itemNumbers.match(new RegExp(sensorType, "g"));
	if(matchesArray){
		return matchesArray.length;
	} else {
		return 0;
	}
}
function getSensorType(itemNo, itemType) { //sensorType: T, H, L etc., d.h. nur ein einziger Buchstabe
	var sensorType = "";
	if(itemType == "Int" || itemType == "Add") {
		sensorType = itemNo.charAt(4);
	} else if(itemType == "Ext") {
		sensorType = itemNo.charAt(5);
	} else if(itemType == "Hou") {
		sensorType = null
	} else if(itemType == "Ana") {
		sensorType = "E";
	}
	return sensorType;
}
function getSensorName(itemNo, itemType) { //sensorName: T, T2, H, P3, L, Exx etc. Bei externen Sensoren wird das F entfernt.
	var sensorName = "";
	if(itemType == "Int" || itemType == "Ana") {
		sensorName = itemNo.substr(4).split("/",1).toString();
	} else if(itemType == "Ext") {
		sensorName = itemNo.substr(5).split("/",1).toString();
	}
	else if(itemType == "Hou" || itemType == "Add") {
		sensorName = null;
	}		
	return sensorName;
}
function getItemQuantity(itemNo) {
	var ddlItemQty = document.getElementById("ddl_" + itemNo + "_qty");
	if(ddlItemQty)
	{
		return ddlItemQty.options[ddlItemQty.selectedIndex].value;
	} else {
		return 1;
	}
}
function countSameExternalSensors(itemNo) { // Zählt in extItems
	var number = 0;
	for(var x in extItems)
	{
		if(x.substr(1,2) == itemNo.substr(5,2)) number += parseInt(extItems[x]);
	}
	return number;
}
function getAnalogueInputConf(itemNo) {
	var dropDownNames = "sct_analogue_input_conf_A";
	var configString = "";
	var configsArray = document.getElementsByName(dropDownNames);
	for(i=0;i<4;i++) {
		configString += configsArray[i].value;
	}
	return configString;
}
function countSelectedAnalogueInputsConf()
{
	var totalCount = 0;
	var count = 0;
	var allPossibleConfigurations = document.getElementsByName("sct_analogue_input_conf");
	for(i=0;i < allPossibleConfigurations.length;i++)
	{
		for (j = 0; j < allPossibleConfigurations[i].length; ++j){
			if (allPossibleConfigurations[i].options[j].selected == true){
				count = parseInt(allPossibleConfigurations[i].options[j].value);
			}
		}
		totalCount += count;
	}
	return totalCount;
}
function resetTdBgColor(itemNo) {
	if(document.getElementById("td_" + itemNo).className.search("dark_col") > -1) {
		document.getElementById("td_" + itemNo).style.backgroundColor = "#DDDDDD";
	} else {
		document.getElementById("td_" + itemNo).style.backgroundColor = "#EEEEEE";
	}
}
function validateMsrConfiguration(language, showMessage) {
	if(housingSelected && internalSensorsCount == 0 && externalSensorsCount == 0 && anaAItemNumber == "") {
		if(showMessage) { alert(CONFIGURATION_WITHOUT_SENSOR[language]); }
		configurationIsValid = false;
		return configurationIsValid;
	} else if(!housingSelected) {
		if(showMessage) { alert(CONFIGURATION_WITHOUT_HOUSING[language]); }
		configurationIsValid = false;
		return configurationIsValid;
	}
	configurationIsValid = true;
	return configurationIsValid;
}